<template>
    <div class="bg-primary text-white" id="difference">
        <div class="container py-5">
        
            <div class="wrapper">
                <div class="left">
                    <h2>The Property Management Experts</h2>
                    <p>Most real estate agencies are focused on selling properties and not property management! Bricks & Mortar are focussed on managing your property not selling it, so you know that you’re in good hands!</p>
                    <a class="btn btn-outline-light" href="#" @click="scrollTo('switchcontact')">Switch Agents Today</a>
                </div>
                <div class="right">
                    <h4>Our Points of Difference</h4>
                    <ul class="icon-list">
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/skilled.png" alt=""></div>
                            <p>Skilled, mature and experienced personnel</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/drone.png" alt=""></div>
                            <p>Drone photography & videography</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/systems.png" alt=""></div>
                            <p>Systems and technology above the rest</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/opens.png" alt=""></div>
                            <p>3x Open For Inspections per week</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/access.png" alt=""></div>
                            <p>Access to your owner portal 24/7</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/strategy.png" alt=""></div>
                            <p>Superior marketing strategies</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/expert.png" alt=""></div>
                            <p>Always called upon for expert advice</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/responsive.png" alt=""></div>
                            <p>Responsive same day service</p>
                        </li>
                        <li>
                            <div class="icon"><img class="lazy" src="@/assets/content/daily.png" alt=""></div>
                            <p>Daily rental disbursements to owners</p>
                        </li>
                    </ul>
                </div>
            </div>
        
        </div>
    </div>
</template>

<style lang="scss">
#difference {
    padding-top: 60px;
    padding-bottom: 60px;
    background-image: url("../assets/content/differences-accent.png");
    background-repeat: no-repeat;
    background-position: left bottom;
    background-size: 20vw;
    border-bottom: solid 1px white;
    
    @media (min-width: 1200px) {
        background-size: 22vw;
    }
    
    .btn {
        margin-top: 40px;
    }
    
    .wrapper {
        @media (min-width: 992px) {
            display: flex;
        }
    }
    
    .left {
        margin-bottom: 60px;
        
        @media (min-width: 992px) {
            margin-bottom: 0;
            margin-right: 100px;
            width: calc(45% - 100px);
        }
        
        h2 {
            font-size: 2.6rem;
            margin-bottom: 20px;
        }
        
        p {
            font-size: 18px;
        }
    }
    
    .right {
        @media (min-width: 992px) {
            width: 55%;
            margin-top: 55px;
        }
        
        h4 {
            font-size: 32px;
            margin-bottom: 30px;
        }
    }
    
    .icon-list {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        overflow: hidden;
        margin-left: -15px;
        margin-right: -15px;
        
        li {
            margin: 15px;
            width: calc(50% - 30px);
            font-size: 14px;
            text-align: center;
            
            @media (min-width: 768px) {
                font-size: 18px;
            }
            
            @media (min-width: 1200px) {
                margin: 20px 20px 30px;
                width: calc(33.33% - 40px);
            }
        }
        
        .icon {
            margin-bottom: 30px;
            
            img {
                display: block;
                margin: 0 auto;
                height: 90px;
            }
        }
    }
}
</style>

<script>
import $ from "jquery";

export default {
  methods: {
    scrollTo(element) {
      let scrollPoint = $("#" + element).offset().top - 150;
      if (scrollPoint < 0) scrollPoint = 0;
      $("html, body").animate(
        {
          scrollTop: scrollPoint
        },
        2000
      );
    }
  }
};
</script>
